<template>
  <b-container fluid>
    <div class="iq-card mt-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title">Role List</h4>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right">
              <button-options
                :access="'master_role'"
                :hideAdd="false"
                :hideDetail="true"
                :isRefreshEnabled="true"
                :isRefreshed="isRefreshed"
                @onAddItemClicked="openAddForm"
                @onRefreshed="getData('Refreshed')"/>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="iq-card-body">
        <b-row class="mb-3">
          <b-col md="4" sm="6">
            <input class="form-control" type="text" placeholder="Search by role name" v-model="searchTerm"
              @input="debouncedSearch">
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <role-list
              :access="'master_role'"
              :data="data"
              :loading="isLoading"
              :pagination="pagination"
              @onActionDelete="openDelete"
              @onPageChanged="onPageChanged"
              @update="onUpdated"/>
          </b-col>
        </b-row>
      </div>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayForm">
        <role-form
          :data="currentRole"
          :errors="errors"
          :isSubmit="isSubmit"
          @onSubmitClicked="onSubmitClicked"
          @onCancelAddClicked="onCancel" />
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayDeletion">
        <delete-item
          :isSubmit="isSubmit"
          @onCancelDeletion="displayDeletion = false"
          @onConfirmDeletion="onConfirmDeletion"/>
      </b-modal>
    </div>
  </b-container>
</template>

<script>

import ButtonOptions from '@/components/directives/button-options';
import DeleteItem from '@/components/directives/delete-item';
import RoleForm from '@/components/userrole/role/Form';
import RoleList from '@/components/userrole/role/List';
import RoleSvc from '@/services/RoleSvc';

import requestBuilder from '@/util/request.builder';

export default {
  name: 'Role',
  components: {
    DeleteItem,
    RoleForm,
    RoleList,
    ButtonOptions,
  },
  data() {
    return {
      currentRole: {},
      data: [],
      displayDeletion: false,
      displayForm: false,
      errors: {},
      filter: {
        roleName: null,
      },
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 50,
        totalSize: 0,
      },
      searchTerm: '',
    };
  },
  methods: {
    async deleteData(notification, data) {
      this.isSubmit = true;
      try {
        const resp = await RoleSvc.delete(data.roleId);
        if (resp.data.status.error === 0) {
          await this.$toast.success(notification);
          this.displayDeletion = await false;
          this.pagination.current = 1;
          this.getData();
        } else {
          this.$toast.error(resp.data.status.message);
        }
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isSubmit = false;
      }
    },
    async getData(notification) {
      this.isLoading = true;
      this.isRefreshed = true;
      try {
        const resp = await RoleSvc.getRoles({
          params: {
            ...requestBuilder.buildFilters(this.pagination, this.filter),
          },
        });
        this.data = resp.data.data;
        this.pagination.totalSize = resp.data.pagination.totalData;
        if (notification) {
          this.$toast.success(notification);
        }
      } catch (e) {
        if (e.response.data) {
          if (e.response.data.status.message === 'Authentication Error') {
            this.doLogOut();
          } else {
            this.$toast.error(e.response.data.status.message);
          }
        } else {
          this.$toast.error('Network error');
        }
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    onCancel() {
      this.currentRole = {};
      this.displayForm = false;
    },
    onConfirmDeletion() {
      this.deleteData('Deleted complete', this.selected);
    },
    onPageChanged(page) {
      this.pagination.current = page;
      this.getData();
    },
    onUpdated() {
      this.getData('Updated');
    },
    async onSubmitClicked(form) {
      this.errors = {};
      this.isSubmit = true;
      try {
        const resp = await RoleSvc.create({ roleName: form.roleName });
        if (resp.data.status.error === 0) {
          await this.getData('Success');
          this.currentRole = {};
          this.displayForm = false;
        } else {
          const errors = resp.data.status.message;
          if (typeof errors === 'object') {
            this.errors = resp.data.status.message;
            this.$toast.error('Error found');
          } else {
            this.$toast.error(resp.data.status.message);
          }
        }
        this.isSubmit = false;
      } catch (e) {
        this.$toast.error(e.response.data.status.message);
        this.isSubmit = false;
      }
    },
    openAddForm() {
      this.currentRole = {};
      this.displayForm = true;
    },
    openDelete(data) {
      this.displayDeletion = true;
      this.selected = data;
    },
    doLogOut() {
      this.$toast.error('Please re-login');
      this.$store.dispatch('auth/logout');
      this.$router.replace({ name: 'Login' });
    },
  },
  created() {
    this.debouncedSearch = this._.debounce(() => {
      this.filter.roleName = this.searchTerm.trim() || null;
      this.pagination.current = 1;
      this.getData();
    }, 400);
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>

</style>
